'use client';
import { setToString } from '../../../core/utilities/set.utils.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { removeCoreProps } from './core.utils.js';
import { renderElem } from './render-element.util.js';
import { processStyleProps } from '../../../core/utilities/swan-style.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
let p = 'Holiday colors are deprecated and will be removed in v4. They have been moved to @vp/marketing-colors and should only be used for Contentful-authored content.', c = {
    holiday: p,
    'holiday-beige-1': p,
    'holiday-green-1': p,
    'holiday-green-2': p,
    'holiday-red-1': p,
    'holiday-red-2': p
};
function RenderComp({ root: p, props: i, propKeysToRemove: l, forwardedRef: a, classNames: s, children: d }) {
    let u = processStyleProps(i, s), b = i.className;
    b && u.add(b), useDeprecatedProps(null, i, [
        {
            propName: 'textColor',
            deprecatedValues: c
        },
        {
            propName: 'backgroundColor',
            deprecatedValues: c
        },
        {
            propName: 'bgc',
            deprecatedValues: c
        }
    ]);
    let y = _object_spread_props(_object_spread({}, removeCoreProps(i)), {
        className: setToString(u)
    });
    return renderElem({
        root: p,
        ref: a,
        renderProps: i,
        props: y,
        children: d
    });
}

export { RenderComp };
